import React, { useState, useEffect } from "react";
import "./InventoryIssue.css";
import { getInventoryIssueLogs } from "../../services/inventoryIssueService";
import { getProducts } from "../../services/productService";
import { AiOutlinePlus, AiOutlineUnorderedList } from "react-icons/ai";
import InventoryIssueModal from "./InventoryIssueModal";
import Popup from "../../components/ui/Popup";

const InventoryIssue = () => {
    const [issueLogs, setIssueLogs] = useState([]);
    const [products, setProducts] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isIssueModalOpen, setIsIssueModalOpen] = useState(false);
    const [popupType, setPopupType] = useState("");
    const [popupMessage, setPopupMessage] = useState("");

    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchIssueLogs();
        fetchProducts();
    }, []);

    // Reset to first page when search query changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    const fetchIssueLogs = async () => {
        try {
            const response = await getInventoryIssueLogs();
            console.log("API Response:", response); // Confirm correct data
            setIssueLogs(Array.isArray(response) ? response : []);
        } catch (error) {
            console.error("Failed to fetch issue logs:", error);
            setIssueLogs([]);
        }
    };



    const fetchProducts = async () => {
        try {
            const response = await getProducts();
            if (Array.isArray(response)) {
                setProducts(response);
            } else if (response && response.data && Array.isArray(response.data)) {
                setProducts(response.data);
            } else {
                console.error("Invalid product data format", response);
                setProducts([]);
            }
        } catch (error) {
            console.error("Failed to fetch products:", error);
            setProducts([]);
        }
    };

    const filteredIssueLogs = Array.isArray(issueLogs) ? issueLogs.filter(log =>
        !searchQuery ||
        log.product_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        log.issued_to.toLowerCase().includes(searchQuery.toLowerCase())
    ) : [];

    // Pagination Logic
    const totalPages = Math.ceil(filteredIssueLogs.length / itemsPerPage);
    const paginatedIssueLogs = filteredIssueLogs.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    return (
        <div className="content-wrapper">
            <Popup message={popupMessage} type={popupType} onClose={() => setPopupMessage("")} />
            <div className="header">
                <h2><AiOutlineUnorderedList /> Inventory Issue Logs</h2>
                <button className="issue-btn" onClick={() => setIsIssueModalOpen(true)}>
                    <AiOutlinePlus /> Issue Inventory
                </button>
            </div>
            <div className="filters">
                <input
                    type="text"
                    placeholder="Search by product or issued to..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>
            <div className="table-wrapper">
                <table>
                    <thead>
                    <tr>
                        <th>Product</th>
                        <th>Quantity</th>
                        <th>Issued To</th>
                        <th>Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {paginatedIssueLogs.map((log) => (
                        <tr key={log.id}>
                            <td>{log.product_name}</td>
                            <td>{log.quantity}</td>
                            <td>{log.issued_to || "N/A"}</td>
                            <td>{new Date(log.issue_date).toLocaleString()}</td>
                        </tr>
                    ))}
                    {paginatedIssueLogs.length === 0 && (
                        <tr>
                            <td colSpan="4" className="no-results">No issue logs found</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
            {/* Pagination Controls */}
            <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                    ← Previous
                </button>
                <span> Page {currentPage} of {Math.max(1, totalPages)} </span>
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
                    Next →
                </button>
            </div>
            {isIssueModalOpen && (
                <InventoryIssueModal
                    onClose={() => setIsIssueModalOpen(false)}
                    onIssueSuccess={() => {
                        fetchIssueLogs();
                        setPopupMessage("Inventory issued successfully!");
                        setPopupType("success");
                    }}
                    products={products}
                />
            )}
        </div>
    );
};

export default InventoryIssue;